import React from 'react';
import './index.css';
import Dashboard from './components/Dashboard';

function App() {
  return <Dashboard />;
}

export default App;
